export default __webpack_public_path__ + "static/media/logo-update.05cb35a1.svg";